import React from "react"
import { css } from "@emotion/core"
import Divider from "components/UI/Divider"
import t from "theme"

const List = ({ items, space, nodivider, ...props }) => (
    <div {...props}>
        {items.map((item, index) => (
            <div>
                {item}
                {index + 1 < items.length && (
                    <Divider
                        size="60%"
                        color={t.color.light}
                        css={css`
                            visibility: ${nodivider ? "hidden" : "inherit"};
                            margin: calc(${space} / 2) 0;
                        `}
                    />
                )}
            </div>
        ))}
    </div>
)

export default List
